import { businessBaseURL } from "./base";
var baseURL = "".concat(businessBaseURL, "/employee");
export var employee = {
    timetables: {
        index: function () { return "".concat(baseURL, "/timetables"); },
    },
};
